export default __webpack_public_path__ + "static/media/magnifier.223e5204.svg";